import React from "react";
import { ProductPrices } from "../ProductPrices/ProductPrices";
import { usePriceCategoryFilter } from "../../../lib/hooks/usePriceCategoryFilter";
import { PriceCategoryDebug } from "../PriceCategoryDebug/PriceCategoryDebug";

interface Props {
  productCategories?: {
    nodes: {
      id: string;
      slug: string;
      name: string;
      databaseId: number;
    }[];
  };
  sale?: string | null;
  regular?: string;
  onSale?: boolean;
  debug?: boolean;
}

export const ConditionalProductPrice = (props: Props) => {
  const productCategoryIds =
    props.productCategories?.nodes
      ?.filter((cat) => cat && cat.databaseId != null)
      .map((cat) => cat.databaseId) || [];

  const shouldShowPrice = usePriceCategoryFilter(productCategoryIds);

  const showDebug = props.debug || false;

  if (shouldShowPrice) {
    return (
      <>
        {showDebug && <PriceCategoryDebug productCategories={props.productCategories} />}
        <ProductPrices
          sale={props.sale}
          regular={props.regular}
          onSale={props.onSale}
        />
      </>
    );
  }

  return (
    <>
      {showDebug && <PriceCategoryDebug productCategories={props.productCategories} />}
    </>
  );
};

